import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_APP_ENV || "local";

let initialized = false;

function isFirstPartySentryHost(hostname: string): boolean {
	return hostname === "firmindex.cz" || hostname.endsWith(".firmindex.cz");
}

export function initSentry() {
	if (initialized || !dsn || typeof window === "undefined") return;
	// React Router imports the SPA root while prerendering the shell. Sentry is
	// browser-only, so hostname filtering must not touch window during that build.
	if (environment === "production" && !isFirstPartySentryHost(window.location.hostname)) return;

	Sentry.init({
		dsn,
		environment,
		integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
		tracesSampleRate: environment === "production" ? 0.1 : 1.0,
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 1.0,
		ignoreErrors: [/Lock .*another request/i],
	});

	initialized = true;
}

export { Sentry };
